﻿import React from "react";
import { observer } from "mobx-react";
import type { IResourcesStore } from "../../../../resources/ResourcesStore";
import type { IUploadStore } from "../../../UploadStore";
import { injectFromApp } from "../../../../shared-components/inject";
import { injectFromAppUpload } from "../../../inject";
import { NotUploadableFilesComponent } from "../not-uploadable/NotUploadableFilesComponent";

interface ISelectedFilesComponentProps {
    resourcesStore?: IResourcesStore;
    uploadStore?: IUploadStore;
}

@injectFromApp<ISelectedFilesComponentProps>((stores) => ({
    resourcesStore: stores.resourcesStore,
}))

@injectFromAppUpload<ISelectedFilesComponentProps>((stores) => ({
    uploadStore: stores.uploadStore,
}))

@observer
export class SelectedFilesComponent extends React.Component<ISelectedFilesComponentProps> {
    resetFiles = (event): void => {
        const { uploadStore } = this.props;
        uploadStore!.resetFiles();
    };

    render() {
        const { resourcesStore, uploadStore } = this.props;
        const { numberOfSelectedFiles } = uploadStore!;

        if (numberOfSelectedFiles <= 0) return null;

        const { numberOfCheckingFiles, somethingIsUploading, filesNotUploadable, numberOfDICOMFiles } = uploadStore!;
        const { resources } = resourcesStore!;

        return (
            <div id={"selected-files-component"}>
                <div>
                    <div id={"checking-selected"} className={"selected-files" + (numberOfCheckingFiles > 0 ? " checking" : "")}>
                        <span>
                            {numberOfCheckingFiles > 0
                                ? resources.CheckingXOfTheXSelectedFiles.replace("{0}", numberOfCheckingFiles.toString()).replace("{1}", numberOfSelectedFiles.toString())
                                : resources.XSelectedFiles.replace("{0}", numberOfSelectedFiles.toString())}
                        </span>
                        <button
                            type="button"
                            className={"silent border"}
                            onClick={this.resetFiles}
                            disabled={numberOfCheckingFiles > 0 || numberOfSelectedFiles === 0 || somethingIsUploading}
                        >
                            {resources.Reset}
                        </button>
                    </div>
                    <div id={"uploadable"} className={"selected-files"}>
                        {resources.XDICOMFiles.replace("{0}", numberOfDICOMFiles.toString())}
                    </div>
                    <div id={"not-uploadable"} className={"selected-files"}>
                        {resources.XUnsupportedFiles.replace("{0}", filesNotUploadable.length.toString())}
                    </div>
                </div>
                <NotUploadableFilesComponent />
            </div>
        );
    }
}
